// Base
import Image from 'next/image'

// Components
import { Flex, Text } from 'yard-utilities/components'
import Section from '@components/v25/section/Section'
import Span from '@components/v25/span/Span'
import MainButton from '@components/v25/ft1/buttons/MainButton'

// Assets
import AirlineImage from '@images/v25/ft1/airlines.png'

// Styles
import styles from './Airlines.module.sass'

interface AirlinesInterfaceProps {
  redirectURL?: string
  onClick?: () => void
}

const Airlines = ({ redirectURL, onClick }: AirlinesInterfaceProps) => {
  return (
    <Section padding={[64, 0]} className={styles.section}>
      <Flex flexDirection="column" rowGap={{ sm: 32 }} center>
        <Text
          tagName="h2"
          variant="title-2"
          align="center"
          transform="capitalize"
        >
          Exclusive Deals from the best airlines
        </Text>

        <Image
          src={AirlineImage}
          alt="Banner of airline logos"
          width={500}
          height={500}
          priority
          className={styles.image}
        />

        <Text tagName="p" variant="body-1" align="center">
          With RatePunk, you get exclusive deals from the best airlines.{' '}
          <Span fontWeight={600}>
            Travel worry-free and save big on every trip!
          </Span>
        </Text>

        <MainButton redirectURL={redirectURL} onClick={onClick} />
      </Flex>
    </Section>
  )
}

export default Airlines
